module.exports = {
  Color: {
    CorePurple100: "#E9EAFF",
    CorePurple200: "#D3D5FF",
    CorePurple300: "#BDC0FE",
    CorePurple400: "#A7ABFE",
    CorePurple500: "#7379FD",
    CorePurple600: "#3F48FD",
    CorePurple700: "#0B16FC",
    CorePurple800: "#020CD0",
    CorePurple900: "#02099C",
    CoreRed100: "#FDE7E4",
    CoreRed200: "#FBCFCA",
    CoreRed300: "#F9B6AF",
    CoreRed400: "#F79E94",
    CoreRed500: "#F47466",
    CoreRed600: "#F04B38",
    CoreRed700: "#E62711",
    CoreRed800: "#B81F0E",
    CoreRed900: "#8A170A",
    CoreOrange100: "#FFF4E3",
    CoreOrange200: "#FFE9C6",
    CoreOrange300: "#FEDDAA",
    CoreOrange400: "#FED28D",
    CoreOrange500: "#FEBF5C",
    CoreOrange600: "#FEBF5C",
    CoreOrange700: "#F59602",
    CoreOrange800: "#C47802",
    CoreOrange900: "#935A01",
    CoreYellow100: "#FBFFE4",
    CoreYellow200: "#F7FFC9",
    CoreYellow300: "#F2FEAD",
    CoreYellow400: "#EEFE92",
    CoreYellow500: "#E6FE60",
    CoreYellow600: "#DFFD2F",
    CoreYellow700: "#D3F802",
    CoreYellow800: "#A9C602",
    CoreYellow900: "#7F9501",
    CoreGreen100: "#E2F9F0",
    CoreGreen200: "#C6F2E2",
    CoreGreen300: "#A7E3BD",
    CoreGreen400: "#A9ECD3",
    CoreGreen500: "#76D397",
    CoreGreen600: "#41D49D",
    CoreGreen700: "#2BBC86",
    CoreGreen800: "#22966B",
    CoreGreen900: "#1A7150",
    CoreTeal100: "#E6FDFF",
    CoreTeal200: "#CDFAFF",
    CoreTeal300: "#9BF5FE",
    CoreTeal400: "#9BF5FE",
    CoreTeal500: "#68F0FD",
    CoreTeal600: "#36EBFD",
    CoreTeal700: "#03E6FC",
    CoreTeal800: "#02B8CA",
    CoreTeal900: "#028A98",
    CoreBlue100: "#E3EEFF",
    CoreBlue200: "#C6DDFF",
    CoreBlue300: "#AACBFE",
    CoreBlue400: "#8DBAFE",
    CoreBlue500: "#5C9CFE",
    CoreBlue600: "#2B7FFD",
    CoreBlue700: "#0263F5",
    CoreBlue800: "#024FC4",
    CoreBlue900: "#013B93",
    CoreSlate25: "#F9F9FA",
    CoreSlate50: "#F5F5F6",
    CoreSlate100: "#F1F1F2",
    CoreSlate200: "#E2E2E3",
    CoreSlate300: "#DBDBDB",
    CoreSlate400: "#CCCCCC",
    CoreSlate500: "#BDBDBD",
    CoreSlate600: "#A0A0A0",
    CoreSlate700: "#848484",
    CoreSlate800: "#707070",
    CoreSlate900: "#565656",
    CoreSlate1000: "#434343",
    CoreSlate1100: "#313131",
    PrimaryBlack: "#000000",
    PrimaryWhite: "#FFFFFF",
    PrimaryPurple: "#3F48FD",
    PrimaryRed: "#F04B38",
    PrimaryOrange: "#F59602",
    PrimaryYellow: "#DFFD2F",
    PrimaryGreen: "#41D49D",
    PrimaryTeal: "#36EBFD",
    PrimaryBlue: "#2B7FFD",
    BackgroundPrimary: "#FFFFFF",
    BackgroundSecondary: "#F1F1F2",
    BackgroundButtonDefault: "#DBDBDB",
    BackgroundButtonDefaultActive: "#CCCCCC",
    BackgroundButtonDefaultDisabled: "#E2E2E3",
    BackgroundButtonText: "#FFFFFF",
    BackgroundButtonTextActive: "#E2E2E3",
    BackgroundButtonTextDisabled: "#F5F5F6",
    BackgroundButtonPrimary: "#3F48FD",
    BackgroundButtonPrimaryActive: "#02099C",
    BackgroundButtonPrimaryDisabled: "#A7ABFE",
    BackgroundButtonDanger: "#F04B38",
    BackgroundButtonDangerActive: "#8A170A",
    BackgroundButtonDangerDisabled: "#F79E94",
    BackgroundInputDefault: "#FFFFFF",
    BackgroundInputDisabled: "#F1F1F2",
    BackgroundInputActiveDisabled: "#AACBFE",
    BackgroundInputCheckbox: "#FFFFFF",
    BackgroundInputCheckboxChecked: "#0263F5",
    BackgroundInputCheckboxDisabled: "#AACBFE",
    BackgroundInputToggle: "#BDBDBD",
    BackgroundInputToggleDisabled: "#DBDBDB",
    BackgroundInputToggleChecked: "#0263F5",
    BackgroundInputToggleCheckedDisabled: "#AACBFE",
    BackgroundInputToggleDanger: "#B81F0E",
    BackgroundInputToggleDangerDisabled: "#F79E94",
    BackgroundLabelGrey: "#E2E2E3",
    BackgroundLabelGreyHover: "#CCCCCC",
    BackgroundLabelGreyDisabled: "#F5F5F6",
    BackgroundLabelDarkGrey: "#848484",
    BackgroundLabelDarkGreyHover: "#707070",
    BackgroundLabelDarkGreyDisabled: "#F1F1F2",
    BackgroundLabelPurple: "#A7ABFE",
    BackgroundLabelPurpleHover: "#7379FD",
    BackgroundLabelPurpleDisabled: "#D3D5FF",
    BackgroundLabelRed: "#F79E94",
    BackgroundLabelRedHover: "#F04B38",
    BackgroundLabelRedDisabled: "#FBCFCA",
    BackgroundLabelDarkRed: "#F04B38",
    BackgroundLabelDarkRedHover: "#B81F0E",
    BackgroundLabelDarkRedDisabled: "#F9B6AF",
    BackgroundLabelOrange: "#FEBF5C",
    BackgroundLabelOrangeHover: "#F59602",
    BackgroundLabelOrangeDisabled: "#FFE9C6",
    BackgroundLabelYellow: "#E6FE60",
    BackgroundLabelYellowHover: "#A9C602",
    BackgroundLabelYellowDisabled: "#F7FFC9",
    BackgroundLabelGreen: "#C6F2E2",
    BackgroundLabelGreenHover: "#2BBC86",
    BackgroundLabelGreenDisabled: "#C6F2E2",
    BackgroundLabelTeal: "#68F0FD",
    BackgroundLabelTealHover: "#02B8CA",
    BackgroundLabelTealDisabled: "#CDFAFF",
    BackgroundLabelBlue: "#5C9CFE",
    BackgroundLabelBlueHover: "#0263F5",
    BackgroundLabelBlueDisabled: "#C6DDFF",
    BackgroundLabelWhite: "#FFFFFF",
    BackgroundLabelWhiteHover: "#DBDBDB",
    BackgroundLabelWhiteDisabled: "#FFFFFF",
    BackgroundDocsNoteDefault: "#FBFFE4",
    BackgroundDocsNoteFeedback: "#E3EEFF",
    BackgroundDocsNoteActionItem: "#FDE7E4",
    BackgroundDocsNoteFlow: "#E9EAFF",
    BackgroundDocsFrameLabelSlate: "#434343",
    BackgroundDocsFrameLabelPurple: "#3F48FD",
    BackgroundDocsFrameLabelBlue: "#2B7FFD",
    BackgroundDocsFrameLabelRed: "#F04B38",
    TextPrimary: "#313131",
    TextSecondary: "#848484",
    TextInverse: "#FFFFFF",
    TextActive: "#3F48FD",
    TextDanger: "#B81F0E",
    TextDisabled: "#BDBDBD",
    BorderHairline: "#F1F1F2",
    BorderDivider: "#E2E2E3",
    BorderIconPrimary: "#434343",
    BorderIconSecondary: "#707070",
    BorderIconInverse: "#FFFFFF",
    BorderIconActive: "#0B16FC",
    BorderIconSuccess: "#22966B",
    BorderIconWarning: "#A9C602",
    BorderIconDanger: "#B81F0E",
    BorderIconDisabled: "#BDBDBD",
    BorderIconLabelGrey: "#707070",
    BorderIconLabelGreyDisabled: "#F1F1F2",
    BorderIconLabelDarkGrey: "#565656",
    BorderIconLabelDarkGreyDisabled: "#E2E2E3",
    BorderIconLabelPurple: "#02099C",
    BorderIconLabelPurpleDisabled: "#D3D5FF",
    BorderIconLabelRed: "#8A170A",
    BorderIconLabelRedDisabled: "#FBCFCA",
    BorderIconLabelDarkRed: "#FFFFFF",
    BorderIconLabelDarkRedDisabled: "#FFFFFF",
    BorderIconLabelOrange: "#935A01",
    BorderIconLabelOrangeDisabled: "#FFE9C6",
    BorderIconLabelYellow: "#7F9501",
    BorderIconLabelYellowDisabled: "#F2FEAD",
    BorderIconLabelGreen: "#1A7150",
    BorderIconLabelGreenDisabled: "#C6F2E2",
    BorderIconLabelTeal: "#028A98",
    BorderIconLabelTealDisabled: "#9BF5FE",
    BorderIconLabelBlue: "#013B93",
    BorderIconLabelBlueDisabled: "#C6DDFF",
    BorderIconLabelWhite: "#848484",
    BorderIconLabelWhiteDisabled: "#F1F1F2",
    BorderInputDefault: "#BDBDBD",
    BorderInputCheckbox: "#707070",
    BorderInputActive: "#0263F5",
    BorderInputDanger: "#F04B38",
    BorderInputDisabled: "#DBDBDB",
    BorderNoteDefault: "#DFFD2F",
    BorderNoteFeedback: "#2B7FFD",
    BorderNoteActionItem: "#F04B38",
    BorderNoteFlow: "#3F48FD",
  },
};
